export default function InfoEmbedQuiziz() {
  const url = 'https://wayground.com/embed/quiz/6569ec5ead20f324db505474'
  return (
    <div
      className="mt-2 border rounded alert alert-warning w-100"
      role="alert"
    >
      <h6>
        <i className="fas fa-info-circle mr-1" />
        Mendapatkan link embed dari Quiziz
      </h6>
      <ol className="mb-0 pl-4">
        <li>
          Buka Quiziz, pilih kuis yang ingin dibagikan
        </li>
        <li>
          Klik tombol <strong>Bagikan</strong> / <strong>Share</strong>
        </li>
        <li>
          Pilih opsi <strong>Embed</strong>
        </li>
        <li>
          Salin/copy <strong>link embed</strong> yang diberikan
        </li>
        <li>
          Contoh: {' '}
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-break">
            {url}
          </a>
        </li>
      </ol>
    </div>
  )
}